import script from "./IModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IModal.vue?vue&type=script&setup=true&lang=js"

import "./IModal.vue?vue&type=style&index=0&id=47c31dda&lang=scss"

const __exports__ = script;

export default __exports__